export { EmptySearchVector } from './empty-search-vector';
